import React, { useState } from "react";
import { Link } from "react-router-dom";

interface Message {
  text: string;
  sender: "user" | "ai"; // Define sender types
}

const AiChat: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (!input.trim()) return;

    // Add user message
    const newMessage: Message = { text: input, sender: "user" };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    // Simulate AI response
    setTimeout(() => {
      const aiResponse: Message = { text: "This is an AI response!", sender: "ai" };
      setMessages((prevMessages) => [...prevMessages, aiResponse]);
    }, 1000);

    setInput("");
  };

  // Function to clear chat
  const handleNewChat = () => {
    setMessages([]); // Clears chat history
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="mb-1">AI Chat</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Application</li>
                <li className="breadcrumb-item active" aria-current="page">
                  AI Chat
                </li>
              </ol>
            </nav>
          </div>
          {/* New Chat Button */}
          <button className="btn btn-outline-info" onClick={handleNewChat}>
            New Chat
          </button>
        </div>

        <div className="card bg-white">
          <div className="card-body chat-container">
            <div className="p-6">
              <h1 className="text-2xl font-bold mb-4">Hey, How can I assist you?</h1>

              {/* Chat Box */}
              <div className="border p-4 rounded overflow-y-auto">
                {messages.map((msg, index) => (
                  <div key={index} className={`p-2 my-2 rounded ${msg.sender === "user" ? "bg-blue-200" : "bg-gray-200"}`}>
                    <strong>{msg.sender === "user" ? "You" : "AI"}: </strong> {msg.text}
                  </div>
                ))}
              </div>

              {/* Input Field & Send Button - Single Row */}
              <div className="row gx-3 gy-2 align-items-center mt-0">
                <div className="col-md-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Message AI"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSend()}
                  />
                </div>
                <div className="col-auto">
                  <button className="btn btn-primary" onClick={handleSend}>
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>    
        </div>
      </div>
    </div>
  );
};

export default AiChat;